var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnlink = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M6.85 14.648h2.056v1.641H6.849a5.556 5.556 0 0 1-5.326-5.742A6.02 6.02 0 0 1 3.054 6.51 5.15 5.15 0 0 1 6.85 4.805h2.057v1.64H6.849a3.5 3.5 0 0 0-2.58 1.182 4.3 4.3 0 0 0-1.095 2.92 3.916 3.916 0 0 0 3.675 4.101m6.3-9.843h-2.057v1.64h2.056a3.916 3.916 0 0 1 3.686 4.102 4.3 4.3 0 0 1-1.093 2.92 3.5 3.5 0 0 1-2.582 1.181h-2.067v1.641h2.056a5.15 5.15 0 0 0 3.796-1.706 6.02 6.02 0 0 0 1.53-4.036 5.556 5.556 0 0 0-5.326-5.742m-.383 7.383-1.608-1.641 1.608-1.64-1.16-1.094L10 9.387 8.392 7.812l-1.16 1.094 1.608 1.64-1.608 1.642 1.16 1.093 1.607-1.575 1.608 1.575z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlink);
export default ForwardRef;